var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbDownCurved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 12.25C21.25 13.3546 20.3546 14.25 19.25 14.25H18.25C17.1454 14.25 16.25 13.3546 16.25 12.25V5.75C16.25 4.64543 17.1454 3.75 18.25 3.75H19.25C20.3546 3.75 21.25 4.64543 21.25 5.75V12.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.587 21.1915L12.0582 21.25C13.5 16.5 16.25 15.5366 16.25 12.7163V6.05504C16.25 5.25261 15.7858 4.51099 15.0271 4.23642C12.4523 3.30469 9.75909 3.10538 7.03639 3.33986C5.37371 3.48306 4.07077 4.75909 3.70442 6.37718L2.82727 10.2514C2.38907 12.1869 3.87013 14.0267 5.86638 14.0267H10.4815L9.49609 17.2092C8.92665 19.0484 9.6657 20.9528 11.587 21.1915Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownCurved);
export default __webpack_public_path__ + "static/media/thumb-down-curved.77bd7478f67ac210f8aab3f530e4965d.svg";
export { ForwardRef as ReactComponent };